import React from "react";
import Header from "./header";
import Sidebar from "./sidebar";
import ThemeProvider from "../../context/themeContext";
import { Provider } from "jotai";
import GlobalDrawer from "./container";
import GlobalModal from "./modal";
import PopUp from "../../component/popUp";

function JotaiProvider({ children }: React.PropsWithChildren<{}>) {
  return <Provider>{children}</Provider>;
}

export default function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <JotaiProvider>
      <PopUp />
      <main className="flex min-h-screen flex-grow">
        <Sidebar className="fixed hidden bg-background xl:block" />
        <div className="flex w-full flex-col xl:ms-[278px] xl:w-[calc(100%-278px)] 2xl:ms-[279px] 2xl:w-[calc(100%-278px)]">
          <Header />
          <div className="flex flex-grow flex-col px-[15px] pb-6 pt-2 md:px-[64px] lg:px-6 lg:pb-8 3xl:px-8 3xl:pt-4 4xl:px-10 4xl:pb-9 xl:px-[64px]">
            {children}
          </div>
        </div>
      </main>
      <GlobalDrawer />
      <GlobalModal />
    </JotaiProvider>
  );
}
